export const parseGID = (gid: string) => {
  const [childObjectName, id] = gid.split('shopify/')[1].split('/')
  const [childObjectId, params] = id.split('?')
  return {
    childObjectName,
    childObjectId,
    params,
  }
}
